// extracted by mini-css-extract-plugin
module.exports = {"tooltipText":"TimestampTooltip_tooltipText__vClwN"};